import React from "react";

interface WarningIconProps {
  width?: string | number;
  height?: string | number;
  fill?: string;
}

const WarningIcon: React.FC<WarningIconProps> = ({
  width = 33,
  height = 33,
  fill = "#FDB913",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.375 29.5625H31.625L16.5 3.4375L1.375 29.5625ZM17.875 25.4375H15.125V22.6875H17.875V25.4375ZM17.875 19.9375H15.125V14.4375H17.875V19.9375Z"
        fill={fill}
      />
    </svg>
  );
};

export default WarningIcon;
